var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1D1D22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.333a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5zM10 5a2.083 2.083 0 1 0 0 4.167A2.083 2.083 0 0 0 10 5zm0 6.667a7.496 7.496 0 0 1 6.429 3.635 8.34 8.34 0 0 1-1.233 1.213 5.833 5.833 0 0 0-10.393 0 8.361 8.361 0 0 1-1.232-1.213A7.496 7.496 0 0 1 10 11.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm0 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.52a6f15de06812f726ca8787fa6dfedd.svg";
export { ForwardRef as ReactComponent };